import React, { useEffect, useState } from 'react';
import { message, Button, Checkbox, Form, Input, Row, Col } from "antd";
import { Link } from "react-router-dom";
import IntlMessages from "util/IntlMessages";
import { useAuth } from "authentication";
import AppNotificationContainer from "components/AppNotificationContainer";
import AntDraggableModal from 'components/AntDraggableModal';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';
import Cookies from 'js-cookie';
import loginBackground from '../assets/images/login-background-epi.png';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import './SignIn.css';

const SignIn = () => {
  const { isLoading, error, setError, userLogin, loginSecurityCodeData, showLoginSecurityCode, setShowLoginSecurityCode, checkLoginSecurityCode } = useAuth();
  const [showResetPassword, setShowResetPassword] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [loginForm] = Form.useForm();
  const [resetPasswordForm] = Form.useForm();
  const [loginSecurityCodeForm] = Form.useForm();
  const [seconds, setSeconds] = useState(60);
  const [isDisabled, setIsDisabled] = useState(false);

  document.title = 'Login';

  const handleSendCodeClick = () => {
    setIsDisabled(true);
    setSeconds(60);
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      setSeconds(seconds - 1);
      if (seconds === 0) {
        clearInterval(intervalId);
        setIsDisabled(false);
      }
    }, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, [seconds]);

  const onFinishFailed = errorInfo => {
  };

  const onFinish = values => {

    values.Username = values.Username.trim();
    values.Company = 'EPI';

    Cookies.set('HF_EPI_Client_Username', values.Username, { expires: 3650 });
    Cookies.set('HF_EPI_Client_Company', values.Company, { expires: 3650 });
    userLogin(values);
  };

  const onResetPasswordFinish = values => {
    setConfirmLoading(true);
    values.Company = 'EPI';
    httpClient
      .post('System/Login/ResetPassword', values)
      .then(({ data }) => {
        if (data.result) {
          message.info(data.message);
          setShowResetPassword(false);
          setConfirmLoading(false);
        } else {
          message.warning(data.message);
          setConfirmLoading(false);
        }
      })
      .catch(function (error) {
        message.error(error.stack);
        setConfirmLoading(false);
      });
  };

  const onLoginSecurityCodeFinish = values => {
    values.Remember = loginSecurityCodeData.Remember;
    values.ClientUserId = loginSecurityCodeData.data;
    checkLoginSecurityCode(values);
  }

  return (
    <div className="epi-signin-page">
      <div className="epi-signin-page__background" style={{ backgroundImage: `url(${loginBackground})` }}></div>
      <div className="epi-signin-page__property-label" aria-hidden="true">
        <span>EXPRESS PROPERTY INFORMATION</span>
      </div>
      <section className="epi-signin-page__left">
        <img className="epi-signin-page__logo" alt="EPI - express property information" src="/assets/images/epi-Logo.png" />
        <div className="epi-signin-page__hero">
          <h1>Accurate property information. Confident decisions.</h1>
          <div className="epi-signin-page__eyebrow"></div>
          <p>EPI delivers fast, reliable property data and insights across Australia.</p>
        </div>
      </section>
      <section className="epi-signin-page__right">
        <div className="epi-signin-card">
          <div className="epi-signin-card__heading">
            <h2>Welcome back</h2>
            <p>Sign in to access your EPI account.</p>
          </div>
          <Form
            action="/"
            form={loginForm}
            initialValues={{ remember: true }}
            name="basic"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            className="gx-signin-form gx-form-row0">
            <Form.Item className="epi-login-field">
              <label className="epi-login-field__label">Username</label>
              <Form.Item
                name="Username"
                initialValue={Cookies.get('HF_EPI_Client_Username') || ''}
                rules={[{ required: true, message: 'Please input your Username!' }]}
                noStyle
              >
                <Input
                  prefix={<UserOutlined />}
                  placeholder="Enter your username"
                />
              </Form.Item>
            </Form.Item>
            <Form.Item className="epi-login-field">
              <label className="epi-login-field__label">Password</label>
              <Form.Item
                name="Password"
                initialValue=""
                rules={[{ required: true, message: 'Please input your Password!' }]}
                noStyle
              >
                <Input.Password
                  prefix={<LockOutlined />}
                  placeholder="Enter your password"
                />
              </Form.Item>
            </Form.Item>
            {/* <Form.Item
                initialValue={Cookies.get('HF_EPI_Client_Company')}
                rules={[{ required: true, message: 'Please input your Company!' }]} name="Company">
                <Input placeholder="Company" />
              </Form.Item> */}
            <div className="epi-signin-card__options">
              <Form.Item name="Remember" valuePropName="checked">
                <Checkbox><IntlMessages id="app.userAuth.rememberMe" /></Checkbox>
              </Form.Item>
              <button type="button" className="epi-signin-card__forgot" onClick={() => setShowResetPassword(true)}><IntlMessages id="app.userAuth.forgotPassword" /></button>
            </div>
            <Button type="primary" className="epi-signin-card__submit gx-mb-0" htmlType="submit" onClick={() => { handleSendCodeClick(); }}>
              <IntlMessages id="app.userAuth.signIn" /> <span className="epi-signin-card__submit-arrow">→</span>
            </Button>
            {/* <div className="epi-signin-card__divider">or</div> */}
          </Form>
          <AppNotificationContainer loading={isLoading} error={error} setError={setError} />
        </div>
      </section>

      <AntDraggableModal
        title={<IntlMessages id="app.userAuth.resetPassword" />}
        className="epi-signin-modal epi-reset-password-modal"
        open={showResetPassword}
        onOk={() => resetPasswordForm.submit()}
        onCancel={() => {
          setShowResetPassword(false);
          resetPasswordForm.resetFields();
        }}
        confirmLoading={confirmLoading}
        width={500}
        okText="Submit"
        maskClosable={false}
      >
        <div className="epi-reset-password-modal__content">
          <p className="epi-reset-password-modal__tips">
            <IntlMessages id="app.userAuth.resetPasswordTips" />
          </p>

          <Form
            form={resetPasswordForm}
            name="resetPasswordForm"
            onFinish={onResetPasswordFinish}
            onFinishFailed={onFinishFailed}
            className="gx-signin-form gx-form-row0"
          >
            <Form.Item className="epi-login-field">
              <label className="epi-login-field__label">Username</label>
              <Form.Item
                name="Username"
                initialValue=""
                rules={[{ required: true, message: 'Please input your Username!' }]}
                noStyle
              >
                <Input
                  placeholder="Enter your username"
                />
              </Form.Item>
            </Form.Item>

            {/* <Form.Item className="epi-login-field">
              <label className="epi-login-field__label">Company</label>
              <Form.Item
                name="Company"
                initialValue=""
                rules={[{ required: true, message: 'Please input your Company!' }]}
                noStyle
              >
                <Input placeholder="Enter your company" />
              </Form.Item>
            </Form.Item> */}
          </Form>
        </div>
      </AntDraggableModal>

      <AntDraggableModal
        title="Security Code"
        className="epi-signin-modal epi-security-code-modal"
        open={showLoginSecurityCode}
        onCancel={() => {
          setShowLoginSecurityCode(false);
          loginSecurityCodeForm.resetFields();
        }}
        width={500}
        maskClosable={false}
        footer={[
          <Button
            key="back"
            onClick={() => {
              setShowLoginSecurityCode(false);
              loginSecurityCodeForm.resetFields();
            }}
          >
            Cancel
          </Button>,
          <Button
            key="resend"
            className="epi-security-code-modal__resend"
            disabled={isDisabled}
            onClick={() => {
              handleSendCodeClick();
              loginForm.submit();
            }}
          >
            {isDisabled ? `Resend after ${seconds} seconds` : 'Resend code'}
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={() => loginSecurityCodeForm.submit()}
          >
            Submit
          </Button>,
        ]}
      >
        <div className="epi-security-code-modal__content">
          <div
            className="epi-security-code-modal__tips"
            dangerouslySetInnerHTML={{ __html: loginSecurityCodeData.message }}
          />

          <Form
            form={loginSecurityCodeForm}
            name="loginSecurityCodeForm"
            onFinish={onLoginSecurityCodeFinish}
            onFinishFailed={onFinishFailed}
            className="gx-signin-form gx-form-row0"
          >
            <Form.Item className="epi-login-field">
              <label className="epi-login-field__label">Security code</label>
              <Form.Item
                name="Code"
                rules={[{ required: true, message: 'Please input security code' }]}
                noStyle
              >
                <Input
                  prefix={<LockOutlined />}
                  placeholder="Enter your security code"
                />
              </Form.Item>
            </Form.Item>
          </Form>
        </div>
      </AntDraggableModal>
    </div>
  );
};

export default SignIn;
